import React from 'react';
import {
  Users, FolderKanban, Calculator, ShoppingCart, Truck, Video, ShieldCheck,
  Megaphone, BookOpen, BookOpenText, Briefcase, GraduationCap, Send, Tag, FileText, CalendarDays,
} from 'lucide-react';
import SectionHubLayout from '@/components/SectionHubLayout';
import useNotificationCounts from '@/hooks/useNotificationCounts';

const BRAND = {
  name: 'ProDecor',
  fullName: 'Ox Resin ProDecor',
  tagline: 'Decorative Walling',
  primaryColor: '#D5AB09',
  secondaryColor: '#2B2101',
  sectionKey: 'prodecor',
  logo: 'https://customer-assets.emergentagent.com/job_d9177fe4-220c-4669-9998-86c6e454a508/artifacts/4z707ot7_IMG_8289.jpeg',
};

const CATEGORIES = [
  {
    id: 'leads-marketing',
    title: 'Leads & Marketing',
    description: 'Win new work and promote your business',
    icon: Megaphone,
    tiles: [
      { id: 'lead-offers', title: 'Lead Offers', description: 'New ProDecor leads offered to you', icon: Send, path: '/lead-offers?section=prodecor', notifKey: 'offer' },
      { id: 'leads', title: 'Lead Management', description: 'Track ProDecor enquiries through to project', icon: Users, path: '/prodecor/leads', notifKey: 'lead' },
    ],
  },
  {
    id: 'quotes-projects',
    title: 'Quotes & Project Management',
    description: 'Quote, order and deliver',
    icon: Briefcase,
    tiles: [
      { id: 'quote-project', title: 'Customer Quotes', description: 'Customer-facing PDF quotes (coming soon)', icon: Calculator, path: null },
      { id: 'my-orders', title: 'Material Orders', description: 'Build new orders, view pricing & track delivery', icon: Truck, path: '/prodecor/my-orders', notifKey: 'order' },
      { id: 'projects', title: 'Project Management', description: 'Track active ProDecor projects', icon: FolderKanban, path: '/prodecor/projects' },
      { id: 'calendar', title: 'Project Calendar', description: 'Plan your weeks — allocate install stages to days across all jobs', icon: CalendarDays, path: '/prodecor/calendar' },
    ],
  },
  {
    id: 'training-development',
    title: 'Training & Professional Development',
    description: 'Learn the craft and earn the badge',
    icon: GraduationCap,
    tiles: [
      { id: 'videos', title: 'Training Videos', description: 'Tips, tricks & install techniques', icon: Video, path: '/videos/prodecor' },
      { id: 'course-notes', title: 'Course Notes & Training Material', description: 'Course handbook PDF · download or read inline', icon: BookOpenText, path: '/notes/prodecor' },
      { id: 'get-approved', title: 'Become OxApproved', description: 'Track your ProDecor approval status', icon: ShieldCheck, path: '/approval/prodecor' },
    ],
  },
  {
    id: 'toolbox',
    title: 'Toolbox',
    description: 'Marketing kit, calculators & letter templates',
    icon: BookOpen,
    tiles: [
      { id: 'marketing', title: 'Marketing Material', description: 'Branded leaflets, posters, social assets', icon: BookOpen, path: '/marketing-materials?section=prodecor' },
      { id: 'calculators', title: 'Calculators', description: 'Useful documents & reference guides', icon: Calculator, path: '/toolbox?brand=prodecor' },
      { id: 'templates', title: 'Templates', description: 'Quote letters, RAMS, customer emails, T&Cs, warranty & aftercare', icon: FileText, path: '/templates?brand=prodecor' },
    ],
  },
];

const ProDecorHub = () => {
  const { bySectionCategory: notifBSC } = useNotificationCounts();
  return (
    <SectionHubLayout
      brand={BRAND}
      categories={CATEGORIES}
      testIdPrefix="prodecor"
      notifBSC={notifBSC}
    />
  );
};

export default ProDecorHub;
